import { usePlatformComponentContext } from '../../../../contexts';
import { CardOnFileProvider, CardOnFileProviderProps } from '../../../card-on-file/context/card-on-file.context';
import { usePaymentMethodsStateContext } from '../payment-methods-state.context';

export type CardOnFileProviderWrapperProps = React.PropsWithChildren<{
  personId?: string;
  invoiceId?: string;
  onError?: (message: string) => void;
}>;
export const CardOnFileProviderWrapper = ({
  children,
  personId,
  invoiceId,
  onError,
}: CardOnFileProviderWrapperProps) => {
  const { isPublic } = usePlatformComponentContext();
  const { setView, setSelectedPaymentMethod } = usePaymentMethodsStateContext();

  const cardOnFileProps: CardOnFileProviderProps = {
    isPublic,
    personId,
    invoiceId,
    onCardSaved: (pm) => {
      setSelectedPaymentMethod(pm);
      setView('list');
    },
    onCancel: () => {
      setView('list');
    },
    onError,
  };
  return <CardOnFileProvider {...cardOnFileProps}>{children}</CardOnFileProvider>;
};
